export const formatFacilityUnitName = (currentUserResidentRole: any) => {
  return `${currentUserResidentRole?.facilityUnit?.facility?.name} - ${currentUserResidentRole?.facilityUnit?.name}`
}
